module.exports = __webpack_public_path__ + "9a0bc7344ae585f908eee36855a6e01a.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/3/Bonnierforlagen_X_Spotin_news.jpg
// module id = 244
// module chunks = 0